// Plugin slide type `setting` flags whose historical key was misspelled.
//
// The Close-submission flag shipped as `enableStopSubmitssionSetting` (doubled "s").
// The correct key is `enableStopSubmissionSetting`; the host reads both. Generated
// manifests (slide-type-creator) carry BOTH at once: the correct key as a `false`
// baseline and the misspelled key as the real `true` override. So within one entry
// the flag is on when EITHER spelling is true; neither key may mask the other.
const LEGACY_SETTING_KEYS = Object.freeze({
  enableStopSubmitssionSetting: 'enableStopSubmissionSetting',
})

/**
 * Fold each legacy key into its correct key (true when either spelling is true), so a
 * catalogue entry declaring either or both spellings reads the same once merged over
 * the defaults. Run it on the entry's own setting BEFORE the merge, so an entry's
 * `false` still overrides a default `true`. Returns a new object; the input is not mutated.
 */
export function normalizePluginSetting(setting) {
  if (!setting) return setting
  const out = { ...setting }
  Object.entries(LEGACY_SETTING_KEYS).forEach(([legacy, current]) => {
    if (out[legacy] !== undefined) {
      out[current] = out[current] === undefined ? Boolean(out[legacy]) : Boolean(out[current]) || Boolean(out[legacy])
    }
    delete out[legacy]
  })
  return out
}

/** Whether a plugin config enables the host's Close-submission control (either spelling). */
export function isStopSubmissionSettingEnabled(setting) {
  if (!setting) return false
  return Boolean(setting.enableStopSubmissionSetting) || Boolean(setting.enableStopSubmitssionSetting)
}
